import { render, staticRenderFns } from "./PendingSalons.vue?vue&type=template&id=0e6982d0&scoped=true"
import script from "./PendingSalons.vue?vue&type=script&lang=js"
export * from "./PendingSalons.vue?vue&type=script&lang=js"
import style0 from "./PendingSalons.vue?vue&type=style&index=0&id=0e6982d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6982d0",
  null
  
)

export default component.exports